import { ProcedimentoVO } from "./procedimentoVO";
import { CampoSpecificoFascicolazioneVO } from "./campo-specifico-fascicolazioneVO";
import { CampoSpecificoFascicoloVO } from "./campo-specifico-fascicoloVO";
import { TempiConservazioneVO } from "./tempi-conservazioneVO";
import { SettoreVO } from "./settoreVO";
import { StatoAttoEnum } from "../enum/stato-atto-enum";
import { UtenteDTO } from "../dto/utenteDTO";
import { UtenteVO } from "./utenteVO";
import { TipologiaDecretoEnum } from "../enum/tipologia-decreto-enum";
import { StatoNotaEnum } from "../enum/stato-nota-enum";
import { LineeFinanziamentoEnum } from "../enum/linee-finanziamento-enum";
import { TipoNotaLiquidazioneEnum } from "../enum/tipo-nota-liquidazione-enum";

export class FiltroRicercaNotaVO {
  settore: SettoreVO;
  ricercaSemplice: string;
  oggetto: string;
  stato: StatoNotaEnum | StatoNotaEnum[];
  statoDaEscludere: string;
  dataInserimentoDal: string;
  dataInserimentoAl: string;
  estensore: UtenteVO;
  responsabile: UtenteVO;
  numeroRepertorio: number;
  annoRepertorio: number;
  dataRepertoriazioneDal: string;
  dataRepertoriazioneAl: string;
  dataApprovazioneDal: string;
  dataApprovazioneAl: string;
  lineaFinanziamento: LineeFinanziamentoEnum;
  tipologiaNota: TipoNotaLiquidazioneEnum;
  beneficiario: string;
  codiceCor: string;
  presaInCarico: string;
  pageNumber: number;
  sort: string;
  direz: string;
}
